import { combineReducers } from "@reduxjs/toolkit";
import reducers from "./index"; // Importa i tuoi reducer dal file index.js

const rootReducer = combineReducers(reducers);

export default rootReducer;